import {
  Checkbox as InformedCheckbox,
  FormValue,
  FormValues,
  FieldProps,
} from 'informed'
import React from 'react'

type CheckboxProps<V = FormValue, VS = FormValues> = FieldProps<V, VS>

const Checkbox = (props: CheckboxProps) => <InformedCheckbox {...props} />

export default Checkbox
